document.addEventListener('DOMContentLoaded', function() {
  const swatchOptionsList = document.querySelectorAll('.product-swatches-options__list input[type="radio"]');

  swatchOptionsList.forEach(function(radio) {
    radio.addEventListener('click', function(event) {

      const productCard = event.target.closest('.product-item'); // entire product card
      const formContainer = productCard.querySelector('.product-item-form');
      const variantMetaInfo = productCard.querySelector('.variant-meta-info');
      const cardATcBtn = formContainer.querySelector('#buy-now-button');

      // Update variant meta info text
      if (variantMetaInfo && event.target.dataset.text) {
        variantMetaInfo.textContent = event.target.dataset.text;
      }

      // Update variant input
      const variantInput = formContainer.querySelector('input[name="id"]');
      variantInput.value = event.target.dataset.id;

      // Update Add to Cart button
      if (event.target.dataset.available === "true") {
        cardATcBtn.textContent = "ADD TO CART";
        cardATcBtn.removeAttribute('disabled');
      } else {
        cardATcBtn.textContent = "SOLD OUT";
        cardATcBtn.setAttribute('disabled', 'true');
      }

      // Update top product link with variant ID
      const topLink = productCard.querySelector('.product-item__product-title a');
      const productImgLink = productCard.querySelector('.product-item__image-link');
      if (topLink && productImgLink) {
        const baseUrl = topLink.getAttribute('href').split('?')[0]; // remove existing query
        topLink.setAttribute('href', `${baseUrl}?variant=${event.target.dataset.id}`);
        productImgLink.setAttribute('href', `${baseUrl}?variant=${event.target.dataset.id}`);
      }

      console.log('Top link updated to:', topLink ? topLink.getAttribute('href') : 'No link found');
    });
  });
});
